<script>
import { projections } from './../stores.js'

let bbox = "46.479820,-73.076197,46.574068,-72.829004"; // 1.3.0 long/lat EPSG 4326 coordinates e.g.:http://bboxfinder.com/#46.437857,-73.072128,46.570663,-72.745285
let layer = "ALERTS"

function retrieveProjection() {
    var url = new URL("https://geo.weather.gc.ca/geomet"),
    params = {
        lang: "E",
        service: "WMS",
        request: "GetFeatureInfo",
        bbox: bbox,
        version: "1.3.0",
        crs: "EPSG:4326",
        layers: layer,
        query_layers: layer,
        width: 10,
        height: 10,
        i: 5,
        j: 5
    };

    Object.keys(params).forEach(key =>
      url.searchParams.append(key, params[key])
    );

    var request = new Request(url);
    var headers = new Headers();

    var options = {
      method: "GET",
      headers: headers,
      mode: "cors",
      cache: "default"
    };

  return new Promise(fulfil => {
    fetch(request, options).then(response => {
      response.text().then(function(text) {
        var values = text.split("\n");
        for (var i = 0; i < values.length; i++) {
          if (!values[i].includes("headline")) 
            continue;
          let val = values[i];
          try {
            val = val.match(/'(.*?)'/g)[0].replaceAll("'", "")
          } catch {
            // noop
          }
          return fulfil(val);
        }
      });
    });
  });
}
</script>

<style>
.alert {
    padding: 20px;
    text-align: center;
    background-color:rgb(238, 66, 102);
    position: fixed;
    top: 0;
    width: 100%;
    left: 68px;
    z-index: 1;
    font-weight: bold;
    animation: fadeIn ease 1s;
    -webkit-animation: fadeIn ease 1s;
    -moz-animation: fadeIn ease 1s;
    -o-animation: fadeIn ease 1s;
    -ms-animation: fadeIn ease 1s;
}
@media only screen and (max-width: 600px) {
  .alert {
    margin: 10px 0;
    padding: 20px;
    text-align: center;
    background-color: rgb(238, 66, 102);
    position: relative;
    top: 0;
    width: auto;
    left: 0;
    z-index: 1;
    font-weight: bold;
  }
}
@keyframes fadeIn {
0% {opacity:0;}
100% {opacity:1;}
}

@-moz-keyframes fadeIn {
0% {opacity:0;}
100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
0% {opacity:0;}
100% {opacity:1;}
}

@-o-keyframes fadeIn {
0% {opacity:0;}
100% {opacity:1;}
}

@-ms-keyframes fadeIn {
0% {opacity:0;}
100% {opacity:1;}
}
</style>
{#await retrieveProjection() then alert}
    {#if alert}
        <div class="alert alert-warning">⚠️ {alert} ⚠️</div>
    {/if}
{/await}
